$(document).ready(function(){

    // ##############################################
    // ################## Isotope ###################
    // ##############################################

    var $output = $('#output');

    // store filter for each group
    var filters = [];

    var $buttons = $('.filters button');

    var $selects = $('.filters select');

    // Press
    if ($('.press-grid').length) {
        var $container = $('.press-grid').imagesLoaded(function() {
            // init Isotope after all images have loaded
            $container.isotope({
                itemSelector: '.filter-item',
                //getSortData: {
                //  name: '.name',
                //},
                //sortBy: 'name',
                //filter: loadFilters
            });      
        });
    }

    // Stories
    if ($('.stories-grid').length) {
        $buttons.each(function() {
            var $target = $(this);
            var isChecked = $target.hasClass('active');
            var filter = $target.attr('data-filter');
            if ( isChecked ) {
                addFilter( filter );
            } else {
                removeFilter( filter );
            }
        });
        if (!filters.join(',').length) {
            $('#filter-reset').css('visibility', 'hidden');
        }
        var $container = $('.stories-grid').imagesLoaded(function() {
            // init Isotope after all images have loaded
            $container.isotope({
                itemSelector: '.filter-item',
                //getSortData: {
                //  name: '.name',
                //},
                //sortBy: 'name',
                //filter: loadFilters
                filter: filters.join(',')
            });
            $output.text(filters.join(','));

            // display message box if no filtered items
            if (!$container.data('isotope').filteredItems.length) {
                $('#no-results').show();
            } else {
                $('#no-results').hide();
            }

        });    
    }


    // Job Grid
    if ($('.job-grid').length) {

        var itemCounter = $('.filters #filteritems-counter');    
        var loadFilter = [];
        var $loadSelects = $('.filters select');
        $loadSelects.each(function( i, elem ) {
            if (elem.value) {
                loadFilter.push(elem.value);
            }
        });
        loadFilter = loadFilter.join('');
        if (!loadFilter.length) {
            loadFilter = '*';
            $('#filter-reset').css('visibility', 'hidden');
        }
        //console.log('ALL: '+loadFilter);
        var $container = $('.grid').imagesLoaded(function() {
            // init Isotope after all images have loaded
            $container.isotope({
                itemSelector: '.filter-item',
                layoutMode: 'vertical',
                hiddenStyle: {
                    opacity: 0
                },
                visibleStyle: {
                    opacity: 1
                },
                //getSortData: {
                //  name: '.name',
                //},
                //sortBy: 'name',
                filter: loadFilter
            });

            // Set Counter
            itemCounter.text($container.data('isotope').filteredItems.length);

        });

        var $jobGrid = $('.product-grid').closest('.container');
        $jobGrid.find('select').change();

    }


    function addFilter( filter ) {
        if ( filters.indexOf( filter ) == -1 ) {
            filters.push( filter );
        }
    }

    function removeFilter( filter ) {
        var index = filters.indexOf( filter);
        if ( index != -1 ) {
            filters.splice( index, 1 );
        }
    }

    // change is-checked class on buttons
    $buttons.on( 'click', function( event ) {
        var $target = $( event.currentTarget );
        $target.toggleClass('active');
        var isChecked = $target.hasClass('active');
        var filter = $target.attr('data-filter');
        if ( isChecked ) {
            addFilter( filter );
        } else {
            removeFilter( filter );
        }

        if (!filters.join(',').length) {
            $('#filter-reset').css('visibility', 'hidden');
        } else {
            $('#filter-reset').css('visibility', 'visible');
        }

        // filter isotope
        // group filters together, inclusive
        $container.isotope({ filter: filters.join(',') });
        $output.text(filters.join(','));

        // display message box if no filtered items
        if (!$container.data('isotope').filteredItems.length) {
            $('#no-results').show();
        } else {
            $('#no-results').hide();
        }

    });

    $selects.change(function() {

        // map input values to an array
        var exclusives = [];
        var inclusives = [];
        // exclusive filters from selects
        $selects.each(function( i, elem ) {
            if (elem.value) {
                exclusives.push(elem.value);
            }
        });

        // combine exclusive and inclusive filters

        // first combine exclusives
        exclusives = exclusives.join('');

        var filterValue;
        if (inclusives.length) {
            // map inclusives with exclusives for
            filterValue = $.map(inclusives, function( value ) {
                return value + exclusives;
            });
            filterValue = filterValue.join(', ');
        } else {
            filterValue = exclusives;
        }

        if (!filterValue.length) {
            $('#filter-reset').css('visibility', 'hidden');
        } else {
            $('#filter-reset').css('visibility', 'visible');
        }

        $output.text(filterValue);
        $container.isotope({ filter: filterValue });

        // display message box if no filtered items
        if (!$container.data('isotope').filteredItems.length) {
            $('#no-results').show();
        } else {
            $('#no-results').hide();
        }

        if ($('.job-grid').length) {
            // Update Counter
            itemCounter.text($container.data('isotope').filteredItems.length);
        }

    });


    $('#no-results .btn, #filter-reset').on( 'click', function(e) {
        e.preventDefault();

        $container.isotope({ filter: '*' });

        if ($selects.length) {
            var filterValue = '';
            var exclusives = [];
            var inclusives = [];
            $output.text(filterValue);
            $('.filters-select').selectpicker('val', '');
            $('.filters-select').selectpicker('refresh');
        }

        if ($buttons.length) {
            // reset filters
            filters = [];
            // reset buttons
            $buttons.each(function() {
                $(this).removeClass('active');
            });
            $output.text(filters);
        }

        $('#no-results').hide();
        $('#filter-reset').css('visibility', 'hidden');
    });

});



// WEBPACK FOOTER //
// ./js/parts/isotope.js